// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OtpVerificationPhone_otpVerificationPhoneContainer__\\+ZAHe .OtpVerificationPhone_otpInputClassName__6M2PU {
  border-radius: 10px;
  caret-color: var(--emarald-green-color);
}
.OtpVerificationPhone_otpVerificationPhoneContainer__\\+ZAHe .OtpVerificationPhone_otpWrapperClassName__NlcN2 {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/auth/otp-verification-phone/OtpVerificationPhone.module.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,uCAAA;AAAR;AAEM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAAR","sourcesContent":[".otpVerificationPhoneContainer{\n    .otpInputClassName {\n        border-radius: 10px;\n        caret-color: var(--emarald-green-color);\n      }\n      .otpWrapperClassName {\n        display: flex;\n        justify-content: flex-start;\n        margin-bottom: 10px;\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpVerificationPhoneContainer": `OtpVerificationPhone_otpVerificationPhoneContainer__+ZAHe`,
	"otpInputClassName": `OtpVerificationPhone_otpInputClassName__6M2PU`,
	"otpWrapperClassName": `OtpVerificationPhone_otpWrapperClassName__NlcN2`
};
export default ___CSS_LOADER_EXPORT___;
